import type { StorageAdapter } from '@/services/storage/storage-adapter';
import type { Season, CreateSeasonInput, UpdateSeasonInput } from '@/types/season';
import { recordPendingDelete } from './sync-service';
import { posthogService } from '@/services/posthog-service';
import { EVENT_SEASON_CREATED } from '@/services/observability/events';

export class SeasonService {
  constructor(private adapter: StorageAdapter) {}

  async getSeasons(): Promise<Season[]> {
    return this.adapter.getSeasons();
  }

  async getSeason(id: string): Promise<Season | null> {
    return this.adapter.getSeason(id);
  }

  async createSeason(data: CreateSeasonInput): Promise<Season> {
    const season = await this.adapter.createSeason(data);
    posthogService.track(EVENT_SEASON_CREATED);
    return season;
  }

  async updateSeason(id: string, data: UpdateSeasonInput): Promise<Season> {
    return this.adapter.updateSeason(id, data);
  }

  async deleteSeason(id: string): Promise<void> {
    await this.adapter.deleteSeason(id);
    await recordPendingDelete(id, 'season');
  }
}
